import { useEffect, useId, useRef, useState } from "react";

export default function RowActionMenu({
  label = "More actions",
  items = [],
  align = "end",
}) {
  const [open, setOpen] = useState(false);
  const menuId = useId();
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  const visibleItems = items.filter((item) => item && item.hidden !== true);

  if (!visibleItems.length) {
    return null;
  }

  return (
    <div
      ref={rootRef}
      className={`admin-row-menu admin-row-menu--${align}`}
    >
      <button
        type="button"
        className="admin-btn admin-btn--ghost admin-row-menu__trigger"
        aria-expanded={open}
        aria-haspopup="menu"
        aria-controls={menuId}
        onClick={() => setOpen((current) => !current)}
      >
        {label}
      </button>
      {open ? (
        <ul id={menuId} className="admin-row-menu__panel" role="menu">
          {visibleItems.map((item) => (
            <li key={item.key || item.label} role="none">
              <button
                type="button"
                role="menuitem"
                className={`admin-row-menu__item${
                  item.variant === "danger" ? " admin-row-menu__item--danger" : ""
                }`}
                disabled={item.disabled}
                onClick={() => {
                  setOpen(false);
                  item.onClick?.();
                }}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
